import * as stylex from '@stylexjs/stylex';
import { FC } from 'react';
import { styles } from '../../styles';
import { formatRussianPhone } from '@shared/libs/phone-validator';

interface ContactDataBlockProps {
  phone?: string | null;
  email?: string | null;
}

export const ContactDataBlock: FC<ContactDataBlockProps> = ({ phone, email }) => {
  const formattedPhone = phone ? formatRussianPhone(phone) : null;
  const hasContactData = Boolean(phone || email);

  if (!hasContactData) {
    return null;
  }

  return (
    <>
      <section {...stylex.props(styles.dataBlock)}>
        <div {...stylex.props(styles.dataBlockItem)}>
          <div {...stylex.props(styles.dataBlockTitle)}>Данные</div>
          <div {...stylex.props(styles.dataFields)}>
            <div {...stylex.props(styles.dataField)}>
              <span {...stylex.props(styles.dataFieldLabel)}>Телефон:</span>
              <span {...stylex.props(styles.dataFieldValue)}>{formattedPhone ? `+ ${formattedPhone}` : '-'}</span>
            </div>
            <div {...stylex.props(styles.dataField)}>
              <span {...stylex.props(styles.dataFieldLabel)}>E-mail:</span>
              <span {...stylex.props(styles.dataFieldValue)}>{email || '-'}</span>
            </div>
          </div>
        </div>
      </section>
      <div {...stylex.props(styles.borderIcon)}></div>
    </>
  );
};
